<template>
  <div class="contacts-page flex-wrap flex-line" style="height:100%;width:100%;">
    <div class="contacts-sidebar flex-col" style="min-width:280px;max-width:360px;width:32%;height:100%;border-right:1px solid var(--border);background:var(--bg1);">
      <div class="contacts-sidebar-header flex-wrap flex-between flex-center" style="padding:12px 16px;border-bottom:1px solid var(--border);">
        <div class="flex-wrap flex-center split5">
          <BaseIcon icon="md-contacts" size="20" />
          <span style="font-size:16px;font-weight:500;">企业通讯录</span>
          <span v-if="contacts.length" style="font-size:12px;color:var(--text2);">共 {{ contacts.length }} 人</span>
        </div>
        <Button icon="md-refresh" size="small" :loading="loading" @click="fetchContacts">刷新</Button>
      </div>
      <Input
        v-model="searchText"
        placeholder="输入姓名或首字母搜索"
        search
        clearable
        style="margin:10px 16px;width:calc(100% - 32px);"
      />
      <div class="contacts-list" style="flex:1;overflow-y:auto;border-top:1px solid var(--border);">
        <Spin v-if="loading && !contacts.length" fix />
        <template v-if="!loading && !filteredContacts.length">
          <BaseEmpty :msg="searchText ? '未找到匹配的联系人' : '暂无通讯录数据'" />
        </template>
        <div
          v-for="item in filteredContacts"
          :key="item.id"
          class="contacts-list-item flex-wrap flex-center"
          :class="{ 'contacts-list-item--active': selected && selected.id === item.id }"
          @click="selected = item"
        >
          <BaseAvatar :src="contactAvatar(item)" :size="36" style="background:var(--bg2);margin-right:10px;flex-shrink:0;">
            {{ item.name ? item.name[0] : '' }}
          </BaseAvatar>
          <div class="flex-col" style="min-width:0;flex:1;">
            <div class="contacts-list-name">{{ item.name || '未命名' }}</div>
            <div v-if="item.phone" class="contacts-list-sub">{{ item.phone }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="contacts-detail flex-col align-center flex-center" style="flex:1;height:100%;background:var(--bg2);min-width:0;">
      <template v-if="!selected || !selected.id">
        <BaseEmpty msg="请选择联系人" />
      </template>
      <template v-else>
        <BaseAvatar :size="100" :src="contactAvatar(selected)">
          {{ selected.name ? selected.name[0] : '' }}
        </BaseAvatar>
        <div class="contacts-detail-name">{{ selected.name || '未命名' }}</div>
        <div class="contacts-detail-card">
          <div v-if="selected.phone" class="contacts-detail-row">
            <span class="contacts-detail-label">电话</span>
            <a class="contacts-detail-value" :href="`tel:${selected.phone}`">{{ selected.phone }}</a>
          </div>
          <div v-if="selected.email" class="contacts-detail-row">
            <span class="contacts-detail-label">邮箱</span>
            <a class="contacts-detail-value" :href="`mailto:${selected.email}`">{{ selected.email }}</a>
          </div>
          <div v-if="!selected.phone && !selected.email" class="contacts-detail-empty">暂无联系方式</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {pinyin} from 'pinyin-pro';
import {toFullFileUrl} from '@/components/form/form-view-file-helpers';

const API_PATH = '/ent/contacts';

export default {
  data() {
    return {
      loading: false,
      contacts: [],
      selected: {},
      searchText: '',
    };
  },
  computed: {
    filteredContacts() {
      const kw = (this.searchText || '').trim();
      if (!kw) {
        return this.contacts;
      }
      const lower = kw.toLowerCase();
      return this.contacts.filter((item) => {
        const name = item && item.name ? String(item.name) : '';
        if (!name) {
          return false;
        }
        if (name.includes(kw)) {
          return true;
        }
        const initials = pinyin(name, {pattern: 'first', tonType: 'none'}).replace(/\s/g, '').toLowerCase();
        return initials.includes(lower);
      });
    },
  },
  mounted() {
    this.$api.afterLogin(() => {
      this.fetchContacts();
    });
  },
  methods: {
    contactAvatar(item) {
      if (!item) {
        return '';
      }
      const raw = item.avatar || item.photo || '';
      return toFullFileUrl(raw, this.$cos && this.$cos.defaults && this.$cos.defaults.baseURL);
    },
    normalizeList(res) {
      let list = (res && res.data && res.data.data) || (res && res.data) || [];
      if (!Array.isArray(list) && list && Array.isArray(list.list)) {
        list = list.list;
      }
      return Array.isArray(list) ? list : [];
    },
    async fetchContacts() {
      this.loading = true;
      try {
        const res = await this.$api.get(API_PATH);
        this.contacts = this.normalizeList(res);
        if (this.selected && this.selected.id) {
          const current = this.contacts.find((item) => item.id === this.selected.id);
          this.selected = current || {};
        }
      } catch (e) {
        this.$Message.error(e.message || '加载通讯录失败');
        this.contacts = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.contacts-list-item {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  transition: background 0.15s ease;
}

.contacts-list-item:hover {
  background: var(--bg2);
}

.contacts-list-item--active {
  background: var(--primary);
  color: var(--hover-text);
}

.contacts-list-item--active .contacts-list-sub {
  color: rgba(255, 255, 255, 0.82);
}

.contacts-list-name {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contacts-list-sub {
  margin-top: 2px;
  font-size: 12px;
  color: var(--text2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contacts-detail-name {
  margin-top: 12px;
  font-size: 28px;
  color: var(--text1);
  text-align: center;
}

.contacts-detail-card {
  width: min(420px, calc(100% - 40px));
  margin-top: 24px;
  padding: 20px 24px;
  background: var(--bg1);
  border: 1px solid var(--border);
  border-radius: 8px;
}

.contacts-detail-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
}

.contacts-detail-row + .contacts-detail-row {
  border-top: 1px solid var(--border);
}

.contacts-detail-label {
  width: 48px;
  flex-shrink: 0;
  color: var(--text2);
}

.contacts-detail-value {
  color: var(--primary);
  word-break: break-all;
}

.contacts-detail-empty {
  text-align: center;
  color: var(--text2);
}
</style>
